import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { PATH } from "../../routes/Routes";
import * as _ from "lodash";

export default function InterfaceMicrosoftAXView() {
  const { t } = useTranslation();
  const history = useHistory();

  const handleMenuClick = (path) => {
    history.push(path);
  };

  const interfaceMicrosoftAXMenus = [
    {
      id: "interface_transaction",
      name: t("menus.interface_ax_menus.log_wood_po"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_LOG_WOOD_PO)
    },
    {
      id: "log_wood_po",
      name: t("menus.interface_ax_menus.processed_wood_po"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_PROCESSED_WOOD_PO)
    },
    {
      id: "processed_wood_po",
      name: t("menus.interface_ax_menus.movement_issue"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_MOVEMENT_ISSUE)
    },
    {
      id: "movement_issue",
      name: t("menus.interface_ax_menus.movement_receipt"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_MOVEMENT_RECEIPT)
    },
    {
      id: "movement_receipt",
      name: t("menus.interface_ax_menus.bom"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_BOM_TRANSACTION)
    },
    {
      id: "export_transaction",
      name: t("menus.interface_ax_menus.export_transaction"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_EXPORT_TRANSACTION)
    },
    {
      id: "bom_transaction",
      name: t("menus.interface_ax_menus.post_baking_waste_wood_count"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_POST_BAKING_WASTE_WOOD_COUNT)
    },
    {
      id: "post_baking_waste_wood_count",
      name: t("menus.interface_ax_menus.waste_wood_order_grading"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_WASTE_WOOD_ORDER_GRADING)
    },
    {
      id: "waste_wood_order",
      name: t("menus.interface_ax_menus.waste_wood_order"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_WASTE_WOOD_ORDER)
    },
    {
      id: "bom_waste_wood",
      name: t("menus.interface_ax_menus.bom_waste_wood"),
      onClick: () => handleMenuClick(PATH.INTERFACE_AX_BOM_WASTE_WOOD)
    },
  ];

  return (
    <div>
      {interfaceMicrosoftAXMenus.map((menu) => (
        <Row>
          <Col
            xs={{ offset: 2, span: 24 }}
            sm={{ offset: 7, span: 12 }}
            lg={{ offset: 9, span: 8 }}
            md={{ offset: 7, span: 13 }}
          >
            <br />
            <Button
              onClick={menu.onClick}
              type="primary"
              size="large"
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {menu.name}
              {<RightOutlined />}
            </Button>
          </Col>
        </Row>
      ))}
    </div>
  );
}
